import { css } from "styled-components/macro";

export const linkBase = css`
  color: blue;
  text-decoration: none;
`;
